import { FeaturedProductsCarouselHelper } from '@/scripts/libs/featured-products-carousel'
import { PlpProduct } from '@/types/plp'
import AlgoliaRecommend from '@/scripts/libs/algolia/recommend'
import Products from '@/scripts/libs/algolia/products'
import { AlgoliaProductHit } from '@/scripts/libs/algolia/types/plp'

class AlgoliaFeaturedProductsCarousel implements FeaturedProductsCarouselHelper {
  async fetchFeaturedProducts({
    partNumber,
    algoliaRecommandation,
    fetchAndAddProductAvailability,
  }: {
    catalogEntries?: string
    partNumber: string
    algoliaRecommandation: {
      type: 'frequentlyBoughtTogether' | 'relatedProducts'
      context: string
    }
    fetchAndAddProductAvailability: (_catEntryId: string) => void
  }): Promise<PlpProduct[]> {
    const { type, context } = algoliaRecommandation

    try {
      if (type === 'frequentlyBoughtTogether') {
        const frequentlyBoughtTogether = await AlgoliaRecommend.getFrequentlyBoughtTogether(
          partNumber
        )

        const hits = frequentlyBoughtTogether?.results?.[0]?.hits
        if (hits) {
          return this.mapFeaturedProducts(hits, fetchAndAddProductAvailability)
        }
        return []
      }
      const relatedProductsResults = await AlgoliaRecommend.getRelatedProducts(partNumber, context)
      const hits = relatedProductsResults?.results?.[0]?.hits
      if (hits) {
        return this.mapFeaturedProducts(hits, fetchAndAddProductAvailability)
      }
      return []
    } catch (e) {
      return []
    }
  }

  private mapFeaturedProducts(
    hits: AlgoliaProductHit[],
    fetchAndAddProductAvailability: (_catEntryId: string) => void
  ) {
    const products = hits.map((product: AlgoliaProductHit) => {
      /* TODO: Populate algolia tracking object */
      const algoliaTracking = {
        grouped: {
          indexName: '',
        },
        ungrouped: {
          indexName: '',
        },
      }
      return Products.normalizeProduct({ product, algoliaTracking })
    })

    products.forEach((product) => fetchAndAddProductAvailability(product.catEntryId))
    return products
  }
}

export default new AlgoliaFeaturedProductsCarousel()
